/**
 * Created by lvsiyuan-young on 2020/06/10.
 * 语言包
 */
let folderFile={};
let readfolder = require.context('../lang', true, /\/.*\/.*.js$/);
	


readfolder.keys().map(function(key){
	let folder = key.split("/")[1];
	folderFile[folder] = {...folderFile[folder] ,...readfolder(key)["default"]};
})



export default folderFile;



// WEBPACK FOOTER //
// ./src/lang/_import.js